import { render, staticRenderFns } from "./PcQuestion.vue?vue&type=template&id=72f58941&"
import script from "./PcQuestion.vue?vue&type=script&lang=js&"
export * from "./PcQuestion.vue?vue&type=script&lang=js&"
import style0 from "./PcQuestion.vue?vue&type=style&index=0&id=72f58941&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/.pnpm/vue-loader@15.10.1_@vue+compiler-sfc@3.2.47_css-loader@5.2.5_webpack@4.47.0_webpack-cli@4.10._l5tjryxt4u4rxr5bwadgd7nxke/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports